// import React, { useState, useRef } from 'react'
// import emailjs from "@emailjs/browser";
// import { Container, Row, Col } from "react-bootstrap";
// import Button from 'react-bootstrap/Button';
// import './Contact.css'

// const Contact = () => {
//   const form = useRef();
//   const [done, setDone] = useState(false)
//   const [notDone, setNotDone] = useState(false)
//   const [formData, setFormData] = useState({});

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value })
//     setDone(false)
//     setNotDone(false)
//   }

//   const sendEmail = (e) => {
//     e.preventDefault();

//     if (!formData.from_name || !formData.reply_to || !formData.message) {
//       setNotDone(true)
//     } else {

//       //  Please use your own credentials from emailjs or i will recive your email

//       emailjs
//         .sendForm(
//           "service_ao3s8xq",
//           "template_ldumlta",
//           form.current,
//           "sKgejTW66FdnEuzuK-"
//         )
//         .then(
//           (result) => {
//             console.log(result.text);
//             setDone(true);
//           },
//           (error) => {
//             console.log(error.text);
//           }
//         );
//     }
//   };


//   return (
//     <Container style={{ paddingTop: '50px' }} >
//       <Row >
//         <Col md={6} className="c-left" >
//           <h1 >Get in Touch</h1>
//           <h1 className="yellow">Contact me</h1>
//         </Col>
//         <Col md={6} className="c-right">
//           <form ref={form} onSubmit={sendEmail}>
//             <input type="text" name="from_name" className="user" placeholder="Name" onChange={handleChange} />
//             <input type="email" name="reply_to" className="user" placeholder="Email" onChange={handleChange} />
//             <textarea name="message" className="user" placeholder="Message" onChange={handleChange} />
//             <span className='not-done' >{notDone && "Please, fill all the input field"}</span>
//             <Button type="submit" className="button" disabled={done}>Send</Button>
//             {/* <span className='done'>{done && "Thanks for contacting me and be sure i have recieved your mail. If you are testing this functionality then i am confirming this thing working perfectly fine. If you have any serious query then i will reply. Also if you need me, you can conatct me on Linkedin."}</span> */}
//             {done && (
//               <div className="done">
//                 Thanks for contacting me and be sure I have received your mail. If you are testing this functionality, then I am confirming it is working perfectly fine. If you have any serious query then I will reply. Also, if you need me, you can contact me on LinkedIn.
//               </div>
//             )}

//           </form>
//         </Col>
//       </Row>
//     </Container>
//   )
// }

// export default Contact
import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "./Contact.css";

const Contact = () => {
  const form = useRef();
  const [done, setDone] = useState(false);
  const [notDone, setNotDone] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    const formEl = form.current;
    const from_name = formEl.from_name.value.trim();
    const reply_to = formEl.reply_to.value.trim();
    const message = formEl.message.value.trim();

    if (!from_name || !reply_to || !message) {
      setNotDone(true);
      setDone(false);
      return;
    }

    emailjs
      .sendForm(
        "service_wq2ol1c",         // ✅ Replace with your actual Service ID
        "template_ldumlta",        // ✅ Replace with your actual Template ID
        form.current,
        "sKgejTW66FdnEuzuK"       // ✅ Replace with your actual Public Key
      )
      .then(
        (result) => {
          console.log("Email sent:", result.text);
          setDone(true);
          setNotDone(false);
          form.current.reset(); // Clear form after sending
        },
        (error) => {
          console.error("Error sending email:", error.text);
          setDone(false);
        }
      );
  };

  return (
    <Container style={{ paddingTop: "50px" }}>
      <Row>
        <Col md={6} className="c-left">
          <h1>Get in Touch</h1>
          <h1 className="yellow">Contact me</h1>
        </Col>
        <Col md={6} className="c-right">
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="from_name"
              className="user"
              placeholder="Name"
            />
            <input
              type="email"
              name="reply_to"
              className="user"
              placeholder="Email"
            />
            <textarea
              name="message"
              className="user"
              placeholder="Message"
            />
            {notDone && (
              <span className="not-done">
                Please fill in all the fields.
              </span>
            )}
            <Button type="submit" className="button">
              Send
            </Button>
            {done && (
              <span className="done">
                Thanks for contacting me and be sure I have received your mail. If you are testing this functionality, then I am confirming it is working perfectly fine. If you have any serious query then I will reply. Also, if you need me, you can contact me on LinkedIn.
              </span>
            )}
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
